/**
 * Секция добавления пользователей
 */

import React from 'react';
import { CreateUserFormComponent } from '../forms/CreateUserForm';

/**
 * Компонент секции "Добавление пользователей"
 */
export const AddUserSection: React.FC = () => {
  return (
    <div>
      <CreateUserFormComponent />
    </div>
  );
};
